import styled from "styled-components";
import { IconButton } from "@mui/material";
import { THEME } from "../../styles/theme";

export const StyledIconButton = styled(IconButton)`
  position: absolute;
  right: 1.2rem;
  top: 1rem;
  color: ${THEME.palette.grey[500]};

  /* Responsividade para mobile */
  @media only screen and (max-width: 900px) {
    right: 0.4rem;
    top: 0.4rem;
  }

  &:hover {
    color: ${THEME.palette.grey[700]};
    background-color: ${THEME.palette.grey[100]};
  }

  &:disabled {
    color: ${THEME.palette.grey[400]};
  }
`;
